import { useState, useEffect } from 'react'
import { Lock } from 'lucide-react'
import './CountdownTimer.css'

interface CountdownTimerProps {
  targetDate: string
}

const CountdownTimer = ({ targetDate }: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState(() => calcTimeLeft(targetDate))

  useEffect(() => {
    const interval = setInterval(() => {
      const left = calcTimeLeft(targetDate)
      setTimeLeft(left)
      if (left.total <= 0) clearInterval(interval)
    }, 1000)

    return () => clearInterval(interval)
  }, [targetDate])

  if (timeLeft.total <= 0) return null

  return (
    <div className="countdown-badge">
      <Lock size={14} color="#FFFFFF" />
      <span>{formatTime(timeLeft)}</span>
    </div>
  )
}

function calcTimeLeft(targetDate: string) {
  const total = new Date(targetDate).getTime() - Date.now()
  if (total <= 0) return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 }

  return {
    total,
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / (1000 * 60)) % 60),
    seconds: Math.floor((total / 1000) % 60),
  }
}

function formatTime(t: { days: number; hours: number; minutes: number; seconds: number }) {
  if (t.days > 0) return `${t.days}д ${t.hours}ч ${t.minutes}м`
  if (t.hours > 0) return `${t.hours}ч ${t.minutes}м ${t.seconds}с`
  return `${t.minutes}м ${t.seconds}с`
}

export default CountdownTimer
